import { mapProps } from 'recompose'
import TireSpecification from './TireSpecification'
import { filterSpecs } from './helpers'

const withFilteredSpecifications = mapProps(({ specification, ...props }) => ({
  ...props,
  specification: filterSpecs(specification)
}))

export default withFilteredSpecifications(TireSpecification)
